import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"
const variants = cva("")

const Label = ({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> &
  VariantProps<typeof variants>) => (
  <LabelPrimitive.Root className={cn(variants(), className)} {...props} />
)
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
